module.exports = __webpack_public_path__ + "static/media/sad.042882d0.jpg";